import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dialogs"
}
const _hoisted_2 = { class: "dialogs__container" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = { class: "card-footer" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

import { useDialogs } from "../dialogs";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogs = useDialogs();

return (_ctx: any,_cache: any) => {
  return (_unref(dialogs).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialogs), (dialog, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "dialog card",
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(dialog.message), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass(dialog.config.confirmClass || 'btn btn-primary'),
                  onClick: ($event: any) => (dialog.confirm())
                }, _toDisplayString(dialog.config.confirmLabel), 11, _hoisted_6),
                _createElementVNode("button", {
                  class: _normalizeClass(
                            dialog.config.cancelClass || 'btn btn-secondary'
                        ),
                  onClick: ($event: any) => (dialog.cancel())
                }, _toDisplayString(dialog.config.cancelLabel), 11, _hoisted_7)
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})